<template>
    <div
        :class="{
            'radio-item': true,
            'radio-item--checked': checked,
        }"
        @click="onClick">
        <div
            v-if="icon"
            class="radio-item__icon d-none d-lg-inline-flex">
            <Icon
                :type="icon"
                :width="55"
                :height="55" />
        </div>
        <div class="radio-item__radio">
            <Icon
                :type="checked ? 'radio_checked_dark' : 'radio'"
                :width="26"
                :height="26" />
        </div>
        <div class="radio-item__content">
            <div
                v-if="title"
                class="radio-item__title">
                {{ title }}
            </div>
            <div
                v-if="text"
                class="radio-item__text">
                {{ text }}
            </div>
        </div>
        <div class="radio-item__icon d-lg-none">
            <Icon
                :type="icon"
                :width="32"
                :height="24" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'RadioItem',
    props: {
        checked: {
            type: Boolean,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        text: {
            type: String,
            default: '',
        },
        icon: {
            type: String,
            default: '',
        },
    },
    methods: {
        onClick () {
            this.$emit('click');
        },
    },
};
</script>

<style scoped lang="scss">
  .radio-item {
    @include font-migrosbank();
    color: $mb-darkgreen;
    background: $mb-grey1;
    cursor: pointer;
    display: flex;

    & ~ .radio-item {
      margin-left: 7px;

      @include media-breakpoint-down(xs) {
        margin-left: 0;
        margin-top: 5px;
      }
    }

    @include media-breakpoint-up(lg) {
      display: block;
      text-align: center;
      flex: 1;
      padding: 35px 10px 30px 10px;
    }
  }

  .radio-item--checked {
    background: $mb-darkgreen;
    color: $mb-white;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
    position: relative;
    z-index: 1;
    .radio-item__content,.radio-item__text {
      color: $mb-white;
    }
  }

  .radio-item__icon {
    text-align: center;

    @include media-breakpoint-down(xs) {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-content: center;
      align-items: flex-end;
      text-align: right;
      flex-basis: auto;
      flex-shrink: 1;
      flex-grow: 0;
      padding: 0 10px;
    }
  }

  .radio-item__radio {
    padding: 3px 0 0 0;

    @include media-breakpoint-down(xs) {
      text-align: left;
      flex-basis: auto;
      flex-shrink: 1;
      flex-grow: 0;
      padding: 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-content: center;
    }
  }

  .radio-item__title {
    font-size: 18px;
    line-height: 18px;

    @include media-breakpoint-down(xs) {
      font-size: 15px;
      line-height: 15px;
    }
  }

  .radio-item__content {
    color: $mb-grey5;
    @include media-breakpoint-down(xs) {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-content: center;
    }
  }

  .radio-item__text {
    color: $mb-grey5;
    font-size: 10px;
    line-height: 16px;

    @include media-breakpoint-down(xs) {
      line-height: 12px;
    }
  }
</style>
